import React from 'react';

import { Route, Redirect, Switch } from 'react-router-dom';
import { ClassificationRulesContainer } from 'components/ClassificationRules';
import { SpendTypeEnum } from 'components/Classification';
import { SettingsNav } from 'views/Settings/SettingsNav';
import SpendTypeSwitch from './SpendTypeSwitch';
import { CONFIG, ROOT_ROUTE } from './routes';

export const ClassificationRules = () => {
  return (
    <React.Fragment>
      <SettingsNav />
      <Switch>
        <Route
          path={`${ROOT_ROUTE}/:spendType(${CONFIG.map((tab) => tab.name).join(
            '|'
          )})`}
          exact
          render={({ match }) => (
            <React.Fragment>
              <SpendTypeSwitch
                spendType={match.params.spendType as SpendTypeEnum}
              />
              <ClassificationRulesContainer
                spendType={match.params.spendType as SpendTypeEnum}
              />
            </React.Fragment>
          )}
        />
        <Redirect to={CONFIG[0].path} />
      </Switch>
    </React.Fragment>
  );
};

export default ClassificationRules;
